module.exports = __webpack_public_path__ + "static/media/WhipAround_android_1.5aacbd01.jpg";